import script from "./OtpVerification.vue?vue&type=script&setup=true&lang=ts"
export * from "./OtpVerification.vue?vue&type=script&setup=true&lang=ts"

import "./OtpVerification.vue?vue&type=style&index=0&id=0729ba85&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0729ba85"]])

export default __exports__